document.addEventListener('DOMContentLoaded', function () {
  // --- Restore saved state on page load ---
  const savedWishList = JSON.parse(localStorage.getItem('wishList') || '[]');
  document.querySelectorAll('.bb-wishlist-btn').forEach(btn => {
    const id = btn.dataset.id;
    const isInWishList = savedWishList.some(p => p.id === id);
    btn.innerHTML = isInWishList
      ? '<i class="ri-heart-fill"></i>'
      : '<i class="ri-heart-line"></i>';
  });


  // --- Handle WishList button click ---
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.bb-wishlist-btn');
    if (!btn) return;

    let wishList = JSON.parse(localStorage.getItem('wishList') || '[]');

    // Prepare product info
    let product = {
      id: btn.dataset.id,
      title: btn.dataset.title,
      price: btn.dataset.price,
      image: btn.dataset.image,
      url: btn.dataset.url,
      category: btn.dataset.category,
      brand: btn.dataset.brand,
      stock: btn.dataset.stock,
      sku: btn.dataset.sku,
      handle: btn.dataset.handle,
      weight: btn.dataset.weight,
      description: btn.dataset.description,
      variantId: btn.dataset.variantId
    };

    const exists = wishList.some(p => p.id === product.id);

    if (exists) {
      // Remove product from list
      wishList = wishList.filter(p => p.id !== product.id);
      btn.innerHTML = '<i class="ri-heart-line"></i>';
    } else {
      // Add product to list
      wishList.push(product);
      btn.innerHTML = '<i class="ri-heart-fill"></i>';
    }

    localStorage.setItem('wishList', JSON.stringify(wishList));


    updateWishListCount();

    // Show popup with count
    showWishListPopup(wishList.length);

  });

  function updateWishListCount() {
    // Try to read the count directly from localStorage
    let count = parseInt(localStorage.getItem('wishListCount') || '0', 10);

    // If wishlist array exists, update the count to stay accurate
    const wishList = JSON.parse(localStorage.getItem('wishList') || '[]');
    count = wishList.length;
    localStorage.setItem('wishListCount', count);

    const badge = document.getElementById('wishlist-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-block' : 'inline-block';
    } else {
      // Retry after 300ms if badge not found yet
      setTimeout(updateWishListCount, 300);
    }
  }

  // ---  Popup function ---
  function showWishListPopup(count) {
    // Remove any existing popup
    const existing = document.querySelector('.bb-wishlist-popup');
    if (existing) existing.remove();

    // Create new popup
    const popup = document.createElement('div');
    popup.className = 'bb-wishlist-popup';
    popup.innerHTML = `
        <h4>Product WishList</h4>
        <p>You have <strong>${count}</strong> product${count !== 1 ? 's' : ''} in your wishlist list.</p>
        <a href="/pages/wishlist" class="bb-btn-2">Go to Wishlist</a>
      `;

    document.body.appendChild(popup);

    // Animate in
    setTimeout(() => popup.classList.add('show'), 50);

    // Auto remove after 5 seconds
    setTimeout(() => {
      popup.classList.remove('show');
      setTimeout(() => popup.remove(), 300);
    }, 5000);
  }

  updateWishListCount();
});